import { useQuery } from 'react-query';
import { fetchChargeReports } from '@/features/chargeReport/services/chargeReportService';
const useChargeReports = (page = 1, filters = {}, all = false, limit = 10) => {
    const { data, error, isLoading, refetch } = useQuery(['chargeReports', { page, filters, all, limit }], () => fetchChargeReports(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 60000,
    });
    return {
        reports: data?.charges || [],
        meta: data?.meta || null,
        loading: isLoading,
        error: error ? error.message : null,
        refetchReports: refetch,
    };
};
export default useChargeReports;
